import ReactMap from "../../../shared/map/map";
import {OverlayView, OverlayViewF, PolygonF, PolylineF} from "@react-google-maps/api";
import mapData from "../../../data/mapData";
import {useState} from "react";

const TripDetailsMap = ({activeStep, getSelectedTripStep, DVRVideoPathNodes}) => {
    const [currentStep, setCurrentStep] = useState(activeStep);
    const getCurrentStep = (step) => {
        setCurrentStep(step);
        getSelectedTripStep(step);
    }

    return (
        <ReactMap>
            {
                <PolylineF path={DVRVideoPathNodes}
                           options={{
                               strokeColor: "#44A9E1",
                               strokeOpacity: 0.4,
                               strokeWeight: 15
                           }}
                />
            }
            {
                <PolygonF
                    path={mapData.cords}
                    options={{
                        fillColor: "yellow",
                        fillOpacity: 0,
                        strokeColor: "#44A9E1",
                        strokeOpacity: 1,
                        strokeWeight: 3
                    }}
                />
            }
            {
                mapData.alertLoc.steps.map((loc) =>
                    <OverlayViewF
                        key={loc.id}
                        position={loc.position}
                        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                    >
                        <div className={`custom-marker ${loc.type} ${loc?.id === activeStep?.id ? 'active' : ''}`}
                             onClick={event => getCurrentStep(loc)}></div>
                    </OverlayViewF>
                )
            }
            {
                <OverlayViewF
                    position={mapData.alertLoc.start}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                    <div className={'custom-marker start-marker'}></div>
                </OverlayViewF>
            }
            {
                <OverlayViewF
                    position={mapData.alertLoc.stop}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                    <div className={'custom-marker end-marker'}></div>
                </OverlayViewF>
            }
        </ReactMap>
    )
}

export default TripDetailsMap;
